module.exports = __webpack_public_path__ + "img/chat_system.0e70a3ee.png";